/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Submit_AnswerInputs */

const en_player_submit_answer = /** @type {(inputs: Player_Submit_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit answer`)
};

const ja_player_submit_answer = /** @type {(inputs: Player_Submit_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回答を送信`)
};

const fr_player_submit_answer = /** @type {(inputs: Player_Submit_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer la réponse`)
};

const de_player_submit_answer = /** @type {(inputs: Player_Submit_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort abgeben`)
};

/**
* | output |
* | --- |
* | "Submit answer" |
*
* @param {Player_Submit_AnswerInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_submit_answer = /** @type {((inputs?: Player_Submit_AnswerInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Submit_AnswerInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_submit_answer(inputs)
	if (locale === "ja") return ja_player_submit_answer(inputs)
	if (locale === "fr") return fr_player_submit_answer(inputs)
	return de_player_submit_answer(inputs)
});